import React from 'react';
import FinalProductListing from './FinalProductListing'
import jQuery from "jquery";

var approvedallSelectedSelectedVariants;

function areComplete(i) {
  return i.variantsSelected !== false;
}

function formatMoney(n, c, d, t) {
	var c = isNaN(c = Math.abs(c)) ? 2 : c,
		d = d == undefined ? "." : d,
		t = t == undefined ? "," : t,
		s = n < 0 ? "-" : "",
		i = String(parseInt(n = Math.abs(Number(n) || 0).toFixed(c))),
		j = (j = i.length) > 3 ? j % 3 : 0;

	return s + (j ? i.substr(0, j) + t : "") + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + t) + (c ? d + Math.abs(n - i).toFixed(c).slice(2) : "");
};

function removeElementHidden(id){
	jQuery(".js-product-" + id + "").removeClass('hidden');
}


function priceCalulator(cart){
	let cartArray = cart
	let totalprice = 0.00
	let total = 0.00
	if (cartArray.length > 0){
		cartArray.map((obj, i) =>
			obj.cartObjects.map((obj2, i) =>
				total += obj2.price * obj2.quanitity
			)
		)
		totalprice = total/100
	}
	return formatMoney(totalprice);
}

class FinalReview extends React.Component {

	constructor(props){
	    // Pass props to parent class
	    super(props);
	    // Set initial state
	    this.state = {
	      panel: 5,
	      sumbmitActive: false,
	      initialized: false,
		  instructionsOverlay: false,
	      cart: [],
	      prints: '',
	      quantities: [],
	      productsToShow: [],
	      panelActive: false
	    }
 
	    this.allPrintsSelected = this.allPrintsSelected.bind(this);
	    this.saveOverlayModification = this.saveOverlayModification.bind(this);
	    this.openOverlay = this.openOverlay.bind(this);
		this.updateNonVariantOptionToCart = this.updateNonVariantOptionToCart.bind(this);
		this.checkIfAllVariantsSelected = this.checkIfAllVariantsSelected.bind(this);
		this.updateChildValue = this.updateChildValue.bind(this);
		this.submitBundle = this.submitBundle.bind(this);
		this.renderFinalCartListing = this.renderFinalCartListing.bind(this);
		this.openInstructionsOverlay = this.openInstructionsOverlay.bind(this);
		this.closeInstructionsOverlay = this.closeInstructionsOverlay.bind(this);
		this.submitBundleAccessibility = this.submitBundleAccessibility.bind(this);
		this.closeInstructionsOverlayAccessibility = this.closeInstructionsOverlayAccessibility.bind(this);

 	
	}

	show(){

		let firstProduct = document.getElementsByClassName("review")[0].getElementsByClassName("item")[0]
		if(firstProduct !== undefined){
			let productUpper = firstProduct.getElementsByClassName("product-upper");
			productUpper[0].focus()
			productUpper[0].blur();
		}
	}

	renderFinalCartListing(itemP, iP, panelP, updateNonVariantOptionToCartP, checkIfAllVariantsSelectedP, openOverlayP, cartP){
		let allproducts = this.props.allProducts;
		let product = allproducts.find(x => x.id === itemP.productID)
		
		if (product) {
			return (
				<FinalProductListing
					ref={instance => (this[`productlistingNew${itemP.productID}`] = instance)}
					item={product}
					key={iP}
					panel={panelP}
					updateNonVariantOptionToCart={updateNonVariantOptionToCartP}
					checkIfAllVariantsSelected={checkIfAllVariantsSelectedP}
					openOverlay={openOverlayP}
					cart={cartP}
				/>
			)
		}
	}
	closeInstructionsOverlayAccessibility(e){
		if(e.which == 13 || e.keyCode == 13) {
			this.closeInstructionsOverlay(e);
		}
	}

	submitBundleAccessibility(e){
		if(e.which == 13 || e.keyCode == 13) {
			this.submitBundle(e);
		}
	}

	allPrintsSelected(){
		this.setState({
	    	sumbmitActive: true
	  	});
	}

  	submitBundle() {
		let cart = [...this.state.cart];

		var esemblyQueue = {
			items: []
		};
		let productsToShow = [];

		cart.map((cartObj) => {
			let objects = cartObj.cartObjects;
			if (objects.length > 0){
				objects.map((Obj) => {
					if(Obj.hasOwnProperty("quanitity") && Obj.quanitity > 0){
						esemblyQueue.items.push({
							quantity: Obj.quanitity,
							id: Obj.id
						});
					}
				});
				productsToShow = objects;
			}
		});
		console.log("QUEUE");
		console.log(esemblyQueue);

		jQuery('body').addClass('overflowHidden');
		jQuery('.kitApp').addClass('overflowHidden');

		this.setState({
			instructionsOverlay: true,
			productsToShow: productsToShow
		}, () =>{

			jQuery.ajax({
		      type: "POST",
		      url: '/cart/clear.js',
		      success: function(){
					jQuery.ajax({
						type: 'POST',
						url: 'https://esemblybaby.com/cart/add.js',
						dataType: 'json',
						data: esemblyQueue,
						success: function(res){
							console.log("RESPONSE");
							console.log(res)
							for (var i = 0; i < res.items.length; i++) {
								let variant = "";
								if(res.items[i].variant_title !== null){
									variant = "<span>" + res.items[i].variant_title + "</span>";
								}
								jQuery('.checkout-flow--products').append("<div class='js-added js-product-"+ res.items[i].id + "'>" + res.items[i].quantity + "<small>x</small>" + res.items[i].product_title + " " + variant + "</div>");
							}
							jQuery('.checkout-flow--products').stop().animate({
							  scrollTop: jQuery('.checkout-flow--products')[0].scrollHeight
							}, 300);
							jQuery('.checkout-flow--end').removeClass('hidden')
						}
					});
				},
		      dataType: 'json'
		    });
		});

	};


	updateNonVariantOptionToCart(cartObj){
		let cart = [...this.state.cart]

		let evalCart = cart.map((productCart) => { 
			if (productCart.productID == cartObj.productID){
				productCart.cartObjects = cartObj.cartObject
				productCart.variantsSelected = true
			}
			return productCart;
		});

		let submitActive = evalCart.every(areComplete);

		this.setState({
			cart: evalCart
		}, () => {
			// this.productlistingNew.printsStateMessage();
			this.setState({
				sumbmitActive: submitActive
			});
		});	
	}

	checkIfAllVariantsSelected(variantLengthOfNewObject){
		let allObjectsTotalQuantity = []
		var allInputValues = document.querySelectorAll(".review .preview-tile-quant");
		let cart = [...this.state.cart]
		let allIds = [];

		for (let item of allInputValues) {
			let elementValue = Number(item.value)
			let elementVariantID = item.getAttribute("id");
			let elementVariantQuantity = item.value
			let obj = {
				'id': elementVariantID,
				'value': elementVariantQuantity
			}
			allIds.push(obj);

		}

		let combinedValuesArray = [];

		let evalCart = cart.map((productCart, vlength) => { 
				allIds.map((product,i) => {
					let finalCount = 0;
					if (product.id == productCart.productID){
						productCart.cartObjects.map((variant,i) => {
							if(variant.quanitity > 0){
								finalCount += variant.quanitity
							}
						});

						if(finalCount == parseInt(product.value) || parseInt(product.value) == 0){
							productCart.variantsSelected = true
						}else{
							productCart.variantsSelected = false
						}

					}
				});

				return productCart
		});

		let submitActive = evalCart.every(areComplete);
		
		this.setState({
			cart: evalCart
		}, () => {
			this.setState({
				sumbmitActive: submitActive
			});
		});	
	}

	updateFinalCart(){
		this.setState({
			cart: this.props.allSelectedProducts
		});
		this.props.allSelectedProducts.map((item,i) =>
			this[`productlistingNew${item.productID}`].updateFinalCartListing(item)
		)
	}

	updateChildValue(quantity, cart){
		this[`productlistingNew${cart.productID}`].updateQuantityFromParent(quantity, cart);
	}

	analyzeDataOnActivation(){
		if(this.state.initialized === false){
			
			this.setState({
				cart: this.props.allSelectedProducts
			});
		}else{
			// do nothing
		}
	}

	saveOverlayModification(quantity, cart, id){
		
		this.setState({
			panelActive: false
		}, () => {
			this.state.cart.map((product,i) => {

				if(cart.productID == product.productID){
					product.cartObjects = cart.cartObject
				}

			});
			this.updateChildValue(quantity, cart);
			this.checkIfAllVariantsSelected(cart.cartObject.length);
			this.props.addProductsToCart(this.state.cart, 5)
		});
	}

	closeInstructionsOverlay(){
		jQuery('.checkout-flow--products').empty();
		jQuery('.checkout-flow--end').addClass('hidden');
		jQuery('body').removeClass('overflowHidden');
		jQuery('.kitApp').removeClass('overflowHidden');
		this.setState({
			instructionsOverlay: false
		});
	}

	openInstructionsOverlay(e, i){
		jQuery('body').addClass('overflowHidden');
		jQuery('.kitApp').addClass('overflowHidden');
		this.setState({
			instructionsOverlay: true
		});
	}


	openOverlay(product, qty, panel, cart, event, isFinalCart){
		this.setState({
			panelActive: true
		}, () => {
			this.props.openOverlay(product, qty, panel, cart, event, isFinalCart)
		});
	}

	updateTotal(cart){
		let cartObj = cart
		this.setState({
			cart: cartObj,
			priceTotal: "TOTAL: $" + priceCalulator(cartObj)
		}, () =>{
		});

	}

	  
	render() {
    	return (
	    	<div className={(this.props.active ? 'active review' : 'review') + " " + (this.state.instructionsOverlay ? 'video' : '') + " " + (this.state.panelActive ? 'hide' : '')} id="panel">

	    		<div className={(this.state.instructionsOverlay ? 'hide-content' : '')}>
	    			<div className="bottom-line">
						<h1>Get excited!<br/>You’re about to Radically Reduce Waste.</h1>
						<div dangerouslySetInnerHTML={{__html: this.props.reviewMeta[0].finalNote}} />
					</div>
					<div className="total">
						<div className="title">TOTAL: ${priceCalulator(this.state.cart)}</div>
						<button className="checkout es-btn" onClick={(e) => this.submitBundle()} onKeyPress={e => this.submitBundleAccessibility(e)}>Add To Cart</button>
					</div>
					<div className="start-over">Make changes as needed below, or click to <a href="https://esemblybaby.com/pages/esemble-your-system">start over</a></div>
					<ul className="product-grid">
						{
							this.props.allSelectedProducts.map((item,i) =>
								this.renderFinalCartListing(item, i, this.props.panel, this.updateNonVariantOptionToCart, this.checkIfAllVariantsSelected, this.openOverlay, item)
							)
						}
					</ul>
				</div><div className={(this.state.instructionsOverlay ? 'open active lightbox-overlay' : ' lightbox-overlay')}>
					<div className="checkout-flow">
						<button className="js-lightbox-close lightbox-close" onClick={e => this.closeInstructionsOverlay()} onKeyPress={e => this.closeInstructionsOverlayAccessibility(e)}><div><span></span></div></button>

						<div className="header">ADDED TO CART:</div>
						<div className="checkout-flow--products">
							
						</div>
						<div className="checkout-flow--end hidden">
							<a className='checkout-inner-cta es-btn' href='/cart'>View Cart</a>
							<button className="plain-cta" onClick={e => this.closeInstructionsOverlay()} onKeyPress={e => this.closeInstructionsOverlayAccessibility(e)}>Clear and go back</button>
						</div>
					</div>
				</div>
			</div>
		)
	}
};

export default FinalReview;